import {
    IMAGE_STYLE_FIXED,
    STANDARD_STYLE,
} from '@eventbrite/eds-media-card-content';
import React from 'react';
import { useSearchServerEnrolledExperiment } from '../../pages/search/context/searchExperiment/SearchServerEnrolledExperiment';
import { SearchEventCardProps } from '../../types/index';
import { SearchEventCard } from './SearchEventCard';

const IMAGE_STYLE_SQUARE = 'square';
const MINI_STYLE = 'mini';

export const SearchEventCardStyleSwitcher: React.FunctionComponent<
    SearchEventCardProps
> = (props) => {
    const experiment = useSearchServerEnrolledExperiment();
    const useGridCards = experiment?.search_event_card_mobile_size === 'grid';

    return (
        <>
            {useGridCards ? (
                <>
                    <div
                        className={`search-event-card-rectangle-image--grid-test`}
                    >
                        <SearchEventCard
                            {...props}
                            style={STANDARD_STYLE}
                            imageStyle={IMAGE_STYLE_FIXED}
                        />
                    </div>
                    <div className="search-event-card-grid">
                        <SearchEventCard
                            {...props}
                            type="grid"
                            containerSpacingClasses=""
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className={`search-event-card-rectangle-image`}>
                        <SearchEventCard
                            {...props}
                            style={STANDARD_STYLE}
                            imageStyle={IMAGE_STYLE_FIXED}
                        />
                    </div>
                    <div className="search-event-card-square-image">
                        <SearchEventCard
                            {...props}
                            style={MINI_STYLE}
                            imageStyle={IMAGE_STYLE_SQUARE}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default SearchEventCardStyleSwitcher;
